import { router } from '../helpers'
import { userService } from '../services'
import vuetifyToast from 'vuetify-toast'
import { getOneUser } from './modules/users/getData'

const userStored = JSON.parse(localStorage.getItem('user'))
const rolesStored = JSON.parse(localStorage.getItem('roles'))

const initialState = () => {
  return {
    user: userStored || null,
    roles: rolesStored || [],
    status: {
      loggedIn: !!userStored
    },
    profileModalActive: false
  }
}

export const authentication = {
  namespaced: true,
  state: initialState(),
  actions: {
    async login ({ dispatch, commit }, { username, password }) {
      commit('loginRequest', { username })
      try {
        let response = await userService.login(username, password)
        dispatch('permissions/setInitUserPermissions', null, { root: true })
        commit('loginSuccess', response.data.data.user)
        vuetifyToast.show({
          text: response.data.message.reason,
          color: 'success',
          timeout: 6000,
          icon: 'check'
        })
        router.push('/')
      } catch (error) {
        commit('logout')
      }
    },
    logout ({ commit }) {
      userService.logout()
      commit('logout')
      router.push({ name: 'login' })
    },
    async refreshPermissions ({ state, dispatch }) {
      if (userStored) {
        dispatch('permissions/setInitUserPermissions', null, { root: true })
        let user = await getOneUser(userStored._id)
        localStorage.setItem('roles', JSON.stringify(user.roles))
        state.roles = user.roles
        delete user.roles
        localStorage.setItem('user', JSON.stringify(user))
        state.user = user
      }
    },
    toggleProfileModal ({ state, commit, dispatch }) {
      if (!state.profileModalActive) { dispatch('users/setOne', state.user._id, { root: true }) }
      commit('toggleProfileModal')
    }
  },
  mutations: {
    loginRequest (state, user) {
      state.status = { loggingIn: true }
      state.user = user
    },
    loginSuccess (state, user) {
      state.status = { loggedIn: true }
      state.roles = user.roles
      delete user.roles
      state.user = user
    },
    logout (state) {
      state.status = {}
      state.user = null
      state.roles = []
    },
    toggleProfileModal (state) {
      state.profileModalActive = !state.profileModalActive
    }
  }
}
